<template>
  <b-card class="mt-3" no-body>
    <b-card-header>
      <h4>
        {{ title }}

        <!-- <b-button
          variant="outline-danger"
          class="ml-1"
          size="sm"
          style="float: left"
          @click="deleteItem"
          v-if="biId > 0"
        >
          <b-icon icon="trash"></b-icon>
        </b-button> -->
      </h4>
    </b-card-header>
    <b-card-body>
      <!-- <b-row>
        <b-col>
          <b-form-group label="از تاریخ">
            <date-picker
              @change="changeFromDate"
              v-model="date_from"
            ></date-picker>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group label="تا تاریخ">
            <date-picker @change="changeToDate" v-model="date_to"></date-picker>
          </b-form-group>
        </b-col>
      </b-row> -->
      <div class="mt-5" style="position: relative">
        <highcharts :options="chartOptions" ref="chart"></highcharts>
        <!-- <div v-if="emptyData" class="sampledata">
          <h2>در بازه انتخابی تراکنشی وجود ندارد</h2>
        </div> -->
      </div>
    </b-card-body>
    <!-- <b-modal
      :id="'my-modal' + biId"
      title="اخطار"
      ok-title="حذف"
      cancel-title="انصراف"
      ok-variant="danger"
      @ok.prevent="confirmDelete()"
    >
      <div class="d-block text-center">
        <h3>آیا مایل به حذف این نمودار هستید؟</h3>
      </div>
    </b-modal> -->
  </b-card>
</template>

<script>
import _ from "lodash";
import { Chart } from "highcharts-vue";
import httpHelper from "@/helpers/httpHelper";
import persianDate from "@/helpers/persianDate";
import * as moment from "jalali-moment";

const dayofweek = [
  "شنبه",
  "یکشنبه ",
  "دوشنبه",
  "سه شنبه",
  "چهارشنبه",
  "پنجشنبه",
  "جمعه",
];

const month = [
  "فروردین ",
  "اردیبهشت",
  "خرداد",
  "تیر",
  "مرداد",
  "شهریور",
  "مهر",
  "آبان",
  "آذر",
  "دی",
  "بهمن",
  "اسفند",
];

// const date = [1,2,3,4,5,6,7,8,9,10,11,
//               12,13,14,15,16,17,18,19,20,21,22,
//               23,24,25,26,27,28,29,30,31
// ];
const date1= parseInt(moment(new Date()).format("jMM"));
let day=null;
date1 > 6 ? day=30 : day =31;
const date = [];
for (let index = 1; index <= day; index++) {
  date.push(index.toString());
}
const colors = ["#1bc5bd", "#ffa800", "#f64e60", "#8950fc", "#6993ff"];

export default {
  props: [
    "chartdatas",
    "charttype",
    "group_col",
    "columns",
    "title",
    "biId",
    "resetcharts",
    "type_opration",
    "XYTitle",
    "seriesName",
    "money_type",
  ],
  components: {
    highcharts: Chart,
  },
  data() {
    return {
      shoIt: false,
      chartOptions: {},
      emptyData: false,
      series: [],
      categories: [],
    };
  },
  watch: {
    chartdatas: function (newVal, oldVal) {
      newVal.length==0 ?  this.$refs.chart.chart.showLoading() :  this.$refs.chart.chart.hideLoading();
      this.initChart();
    },
  },
  mounted() {
    this.initChart();
  },
  methods: {
    initChart() {
      this.emptyData = false;
      this.series = [];
      this.categories = [];
      this.hChartOptions();
      return;
    },
    // CalcResult(data, group_col, columns) {

    //   var self = this;

    //   var g = _.groupBy(data, function(item) {
    //     return item[group_col];
    //   });
    //   const ordered = {};
    //   Object.keys(g)
    //     .sort()
    //     .forEach(function(key) {
    //       ordered[key] = g[key];
    //     });
    //   var return_data = _.mapValues(ordered, function(o) {
    //     var obj = {};
    //     for (let i = 0; i < columns.length; i++) {
    //       const col = columns[i];
    //       if (col.field_type == "sum") {
    //         var s = 0;
    //         obj[col.field_type + "_" + col.field_name] = _.sumBy(o, function(
    //           sItem
    //         ) {
    //           return sItem[col.field_name];
    //         });
    //       } else if (col.field_type == "avg") {
    //         var s = 0;
    //         obj[col.field_type + "_" + col.field_name] =
    //           _.sumBy(o, function(sItem) {
    //             return sItem[col.field_name];
    //           }) / o.length;
    //       } else if (col.field_type == "length") {
    //         obj[col.field_type + "_" + col.field_name] = o.length;
    //       } else if (col.field_type == "min") {
    //         obj[col.field_type + "_" + col.field_name] = _.minBy(o, function(
    //           sItem
    //         ) {
    //           return sItem[col.field_name];
    //         })[col.field_name];
    //       } else if (col.field_type == "max") {
    //         obj[col.field_type + "_" + col.field_name] = _.maxBy(o, function(
    //           sItem
    //         ) {
    //           return sItem[col.field_name];
    //         })[col.field_name];
    //       }
    //     }
    //     return obj;
    //   });
    //   return return_data;
    // },
    hChartOptions() {
      switch (this.charttype) {
        case "line":
          this.drowLineChart();
          break;
        case "bar":
          this.drowbarChart();
          break;
        case "pie":
          this.drowpieChart();
          break;
        case "heat":
          this.drowHeatChart();
          break;

        default:
          break;
      }
      this.shoIt = true;
    },
    drowLineChart() {
      for (let i = 0; i < this.columns.length; i++) {
        if (i >= this.series.length) {
          this.series.push({
            name: this.columns[i].name,
            data: [],
          });
        }
      }
      // this.series.push({
      //   data: [],
      // });
      this.categories = [];
      switch (this.type_opration) {
        case "count":
          this.CreateArrayCount();
          break;
        case "sum":
          this.CreateArraySum();
          break;
      }

      this.chartOptions = {
        chart: {
          type: "spline",
          style: {
            //direction: "rtl",
            fontFamily: "IRANSans",
          },
        },
        title: {
          text: null, //this.title
        },
        colors: ["#1bc5bd", "#ffa800", "#f64e60", "#8950fc", "#6993ff"],
        // subtitle: {
        //   text: "Source: WorldClimate.com"
        // },
        xAxis: {
          categories: this.categories,
          title: {
            text: this.XYTitle.x_title,
            align: "high",
          },
        },
        yAxis: {
          title: {
            text: this.XYTitle.y_title,
            align: "high",
          },
          labels: {
            formatter: function () {
              return this.value;
            },
          },
        },
        legend: {
          enabled: false,
        },
        credits: {
          enabled: false,
        },
        tooltip: {
          useHTML: true,
          formatter: function () {
            return `<div style='direction:rtl;'><h6 style='text-align:right'> 
              ${this.x} 
              </h6> 
              ${this.series.name}
              : 
              ${
                this.type_opration !== "count"
                  ? this.y.toLocaleString()
                  : this.y
              }
              </div>`;
          },
        },
        plotOptions: {
          spline: {
            marker: {
              radius: 4,
              lineColor: "#666666",
              lineWidth: 1,
            },
          },
        },
        series: this.series,
      };
    },
    CreateArrayCount() {
      switch (this.group_col) {
        case "monthly":
          this.chartdatas.forEach((element) => {
            this.categories.push(month[element.date]);
            this.series[0].data.push(element.count);
          });
          let date1 = [];
          date1 = moment(new Date()).format("jYYYY/jMM/jDD");

          this.categories.unshift(
            ...this.categories.splice(moment(date1).month() + 1)
          );
          break;
        case "weekly":
          this.chartdatas.forEach((element) => {
            this.categories.push(dayofweek[element.date]);
            this.series[0].data.push(element.count);
          });
          break;
        case "daily":
          this.chartdatas.forEach((element) => {
            this.categories.push(element.date);
            this.series[0].data.push(parseInt(element.count));
          });
          break;
      }
    },
    CreateArraySum() {
      switch (this.group_col) {
        case "monthly":
          this.chartdatas.forEach((element) => {
            this.categories.push(month[element.date]);
            this.series[0].data.push(element.rialCost);
          });

          let date1 = [];
          date1 = moment(new Date()).format("jYYYY/jMM/jDD");

          this.categories.unshift(
            ...this.categories.splice(moment(date1).month() + 1)
          );
          break;
        case "weekly":
          this.chartdatas.forEach((element) => {
            this.categories.push(dayofweek[element.date]);
            this.series[0].data.push(element.rialCost);
          });
          break;
        case "daily":
          this.chartdatas.forEach((element) => {
            this.categories.push(element.date);
            this.series[0].data.push(element.sum);
          });
          break;

        default:
          break;
      }
    },
    CreateLoneChart() {
      this.chartOptions = {
        chart: {
          type: "areaspline",
          style: {
            //direction: "rtl",
            fontFamily: "IRANSans",
          },
        },
        title: {
          text: null, //this.title
        },
        colors: ["#1bc5bd", "#ffa800", "#f64e60", "#8950fc", "#6993ff"],
        // subtitle: {
        //   text: "Source: WorldClimate.com"
        // },
        xAxis: {
          categories: this.categories,
        },
        yAxis: {
          title: {
            text: null,
          },
          labels: {
            formatter: function () {
              return this.value;
            },
          },
        },
        tooltip: {
          useHTML: true,
          formatter: function () {
            return (
              "<div style='direction:rtl;'><h6 style='text-align:right'>" +
              this.x +
              "</h6>" +
              this.seriesName +
              ":" +
              Number(this.y).toLocaleString() +
              "</div>"
            );
          },
        },
        plotOptions: {
          spline: {
            marker: {
              radius: 4,
              lineColor: "#666666",
              lineWidth: 1,
            },
          },
        },
        series: this.series,
      };
    },
  },
};
</script>

<style scoped>
.highcharts-credits {
  display: none;
}
.sampledata {
  position: absolute;
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;
  background-color: rgba(0, 0, 0, 0.55);
  vertical-align: middle;
  padding-top: 35%;
}
.sampledata h2 {
  color: white;
  text-align: center;
}
</style>
